import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToolsBoxService} from '../Services/tools.service';
import {User} from "../Models/user.model";
import {UserService} from "../Services/user.service";
import {FirstLetterPipe} from '../Pipes/firstletter.pipe';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TrigrammePipe } from '../Pipes/trigramme.pipe';

@Component({
    selector: 'reset-pwd-modal',
    templateUrl: 'resetpwdmodal.component.html',
    imports: [NgClass, ReactiveFormsModule, FormsModule, TrigrammePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordModalComponent implements OnInit {

  @Input() currentUser: User;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  newPassword: string;
  passwordMustBeChanged = true;


  constructor(private userService: UserService, private toolsBoxService: ToolsBoxService) {
  }

  ngOnInit() {
    this.newPassword = this.toolsBoxService.generateRandomString(8);
  }

  close() {
    this.onClose.next(true);
  }

  resetPassword = (): void => {
    //Call the authenticateService and get an Observable
    this.toolsBoxService.tellActionIsInProgress(true);
    this.currentUser.userPasswordTmp = this.passwordMustBeChanged;
    const $returnSubs = this.userService.resetUserPassword(this.currentUser, this.newPassword)
      .subscribe(
        (data) => {
          this.toolsBoxService.tellActionIsInProgress(false);
          //TODO EKA: Display a notif
          this.close();
        },
        (err) => {
          this.toolsBoxService.tellActionIsInProgress(false);
          //TODO EKA: Display a notif
          this.close();
        });
  }

  getStyle = (userName: string): string => {
    const firstLetterPipe = new FirstLetterPipe();
    return "user-first-initial-" + firstLetterPipe.transform(userName);
  }

}
